/* tslint:disable */
import { HttpClient } from '../http-client';

export default (client: HttpClient) => {
  client.instance.interceptors.request.use(request => {
    const scopes = client.authContext.getScopesForEndpoint(request.url!);
    client.authContext.verbose(
      'Url: ' + request.url + ' maps to scopes: ' + scopes
    );

    if (scopes === null) {
      return request;
    }

    const tokenStored = client.authContext.getCachedTokenInternal(
      scopes,
      client.authContext.getAccount(),
      ''
    );

    if (tokenStored && tokenStored.accessToken) {
      request.headers!['Authorization'] = `Bearer ${tokenStored.accessToken}`;
    }

    return request;
  });
};
